import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swallow unhandled axios rejections so they don't trigger the CRA dev
// runtime-error overlay. Loading screens (Promise.all of multiple fetches)
// will fail on isolated 403/404 calls when an RBAC rule tightens or a
// resource gets suspended — the call sites already toast/silently degrade,
// but an unhandled rejection at the page level otherwise punches a giant
// red overlay across the operator's screen. We let real coding errors
// (TypeError, ReferenceError) still surface; only network/axios rejections
// are suppressed.
//
// CRITICAL: register in the CAPTURE phase (third arg = true) so we run
// BEFORE the React/webpack dev-overlay listener, and call
// stopImmediatePropagation() to keep the overlay listener from firing at
// all. The overlay attaches its own listener early; only by capturing can
// we reliably win the race.
const _planGatedSuppress = (e) => {
  const r = e?.reason || e?.error;
  const isAxios = !!(r && (r.isAxiosError || r.config || r.response));
  if (isAxios) {
    e.preventDefault();
    e.stopImmediatePropagation();
    // eslint-disable-next-line no-console
    console.warn("[axios:unhandled]", r?.config?.url, r?.response?.status, r?.message);
  }
};
window.addEventListener("unhandledrejection", _planGatedSuppress, true);
window.addEventListener("error", _planGatedSuppress, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode intentionally disabled. react-leaflet@4 still mounts
// its `MapContainer` inside a `useLayoutEffect` that doesn't tolerate React 18's
// double-effect pass — the second pass throws "Map container is already
// initialized". StrictMode only runs in development; production builds are
// unaffected either way, so removing the wrapper has zero runtime cost.
root.render(<App />);
